import { config as envConfig } from '@config/index';
import axios from 'axios';
// Token getter - reads current token from AuthProvider state
let getToken = null;
// Auth clear handler - clears token/user state when unauthorized
let handleUnauthorized = null;
// Set token getter from AuthProvider
export const setTokenGetter = (getter) => {
    getToken = getter;
};
// Set unauthorized handler from AuthProvider
export const setUnauthorizedHandler = (handler) => {
    handleUnauthorized = handler;
};
// Create axios instance
const httpInstance = axios.create({
    baseURL: envConfig.apiUrl,
    timeout: 30000, // 30 seconds
    headers: {
        'Content-Type': 'application/json',
    },
});
// Request Interceptor - Add auth token to every request
httpInstance.interceptors.request.use((config) => {
    // Add auth token if available
    const token = getToken?.();
    if (token && config.headers) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    // Add app version
    if (config.headers) {
        config.headers['X-App-Version'] = envConfig.appVersion;
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});
// Response Interceptor - Handle errors
httpInstance.interceptors.response.use(response => response, (error) => {
    if (error.response) {
        switch (error.response.status) {
            case 401:
                // Token expired or invalid - clear auth state
                handleUnauthorized?.();
                break;
        }
    }
    return Promise.reject(error);
});
export default httpInstance;
